/**
 * Gets audio file duration.
 *
 * @param   {File}    file  Audio file.
 * @returns {number}    Audio file duration.
 */
export default async function (file) {
    return new Promise(resolve => {
        const url = URL.createObjectURL(file);
        const audio = new Audio(url);

        /**
         * Fires after loading audio.
         */
        const callback = () => {
            resolve(Math.round(audio.duration));

            URL.revokeObjectURL(url);
            audio.removeEventListener('canplaythrough', callback);
        };

        audio.addEventListener('canplaythrough', callback);
    });
}
